import { logoutHandler } from 'auth-component';
function Logout(props) {
    console.debug("Logout : logoutHandler() : ",logoutHandler());
    window.location.assign(logoutHandler());
}

export default Logout;